export default "<p>holidays-table works!</p>\n"